'use client';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue
} from '@ui/select.tsx';
import { cn } from '@r/utils/utils.ts';
import { useTranslation } from 'react-i18next';

type CartItemSelectProps = {
  value?: string;
  onValueChange?: (value: string) => void;
  disabled?: boolean;
  maxQuantity?: number;
  className?: string;
};

const CartItemSelect = ({
  value,
  onValueChange,
  disabled = false,
  maxQuantity = 100,
  className
}: CartItemSelectProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger className={cn('w-[60px]', className)}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>{t('select.default.label')}</SelectLabel>
            {Array.from(
              {
                length: maxQuantity
              },
              (_, i) => (
                <SelectItem key={i} value={String(i + 1)}>
                  {i + 1}
                </SelectItem>
              )
            )}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

CartItemSelect.displayName = 'CartItemSelect';

export default CartItemSelect;
